import { apiClient } from "@/modules/shared/utils/apiClient";

import { ConfirmCancelData } from "../types/ConfirmCancelData";

export const confirmCancel = (data: ConfirmCancelData) =>
  apiClient.post("/coaching-session/cancel/confirm", data);
